function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `trend-logo-mobile`);

const SvgComponent = props => React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 12.73 12.23"
}, props), _ref, React.createElement("path", {
  d: "M9,7H0V5.2H9Z",
  style: {
    "fill": "#ffcb6f"
  }
}), React.createElement("path", {
  d: "M12.73,1.82H0V0H12.73Z",
  style: {
    "fill": "#ffb917"
  }
}), React.createElement("path", {
  d: "M6.63,12.23H.26V10.41H6.63Z",
  style: {
    "fill": "#fedea7"
  }
}));

export default __webpack_public_path__ + "static/media/trend-logo-mobile.485635fa.svg";
export { SvgComponent as ReactComponent };